(function(){
'use strict';
if(window.__kdkMenFacetMerge2026)return;
window.__kdkMenFacetMerge2026=true;
var facetName='filter.p.product_type';
var dictionary={
'Gömlek':['gömlek','gömlekler','gömlekleri','shirt','shirts','button down shirt','button down shirts'],
'Tişört':['tişört','tişörtler','t-shirt','t-shirts','t shirt','t shirts','tshirt','tshirts','tşört','tşörtler','tee','tees'],
'Sneaker':['sneaker','sneakers','spor ayakkabı','spor ayakkabılar','spor ayakkabıları','sports shoes'],
'Kazak':['kazak','kazaklar','sweater','sweaters','pullover','pullovers'],
'Sweatshirt':['sweatshirt','sweatshirts','sweat shirt','sweat shirts'],
'Kapüşonlu':['kapüşonlu','kapüşonlular','hoodie','hoodies','kapşonlu','kapşonlular'],
'Ceket':['ceket','ceketler','jacket','jackets'],
'Blazer':['blazer','blazers'],
'Mont':['mont','montlar','puffer jacket','puffer jackets'],
'Kaban':['kaban','kabanlar','coat','coats'],
'Dış Giyim':['dış giyim','outerwear'],
'Pantolon':['pantolon','pantolonlar','pantolonları','trouser','trousers','pants','pant'],
'Jean':['jean','jeans','denim pantolon','denim pants'],
'Eşofman Altı':['eşofman altı','eşofman altları','jogger','joggers','sweatpant','sweatpants'],
'Şort':['şort','şortlar','short','shorts'],
'Bot':['bot','botlar','boots','boot'],
'Cüzdan':['cüzdan','cüzdanlar','wallet','wallets'],
'Kartlık':['kartlık','kartlıklar','card holder','card holders','cardholder','cardholders'],
'Çanta':['çanta','çantalar','bag','bags'],
'Bel Çantası':['bel çantası','bel çantaları','belt bag','belt bags','waist bag','waist bags'],
'Omuz Çantası':['omuz çantası','omuz çantaları','shoulder bag','shoulder bags'],
'Sırt Çantası':['sırt çantası','sırt çantaları','backpack','backpacks'],
'Çapraz Çanta':['çapraz çanta','çapraz çantalar','crossbody bag','crossbody bags','crossbody'],
'Kemer':['kemer','kemerler','belt','belts'],
'Şapka':['şapka','şapkalar','hat','hats','cap','caps'],
'Atkı':['atkı','atkılar','scarf','scarves'],
'Saat':['saat','saatler','watch','watches'],
'Giyim':['giyim','clothing'],
'Aksesuar':['aksesuar','aksesuarlar','accessory','accessories'],
'Hırka':['hırka','hırkalar','cardigan','cardigans'],
'Yelek':['yelek','yelekler','vest','vests']
};
function slug(s){
return String(s||'').trim().toLocaleLowerCase('tr-TR').replace(/ı/g,'i').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'');
}
var known=new Map();
Object.keys(dictionary).forEach(function(canonical){
dictionary[canonical].concat([canonical]).forEach(function(label){known.set(slug(label),canonical);});
});
function labelFor(s){return known.get(slug(s))||String(s||'').trim();}
function groupKey(s){return slug(labelFor(s));}
function checkCount(li){
var el=li&&li.querySelector('.count-numb');
if(!el)return 0;
var n=Number(el.textContent.replace(/[^\d]/g,''));
return Number.isFinite(n)?n:0;
}
function ensurePreview(form){
var theme=new URLSearchParams(window.location.search).get('preview_theme_id');
if(theme&&!form.querySelector('input[name="preview_theme_id"]')){
var input=document.createElement('input');
input.type='hidden';input.name='preview_theme_id';input.value=theme;form.appendChild(input);
}
}
function normalizeChips(){
var current=new URL(window.location.href);
var selected=current.searchParams.getAll(facetName).reduce(function(all,entry){
return all.concat(entry.split(',').map(function(v){return v.trim();}).filter(Boolean));
},[]);
if(!selected.length)return;
var keys=new Set(selected.map(groupKey));
var visited=new Set();
document.querySelectorAll('a.sr-applied-filter-remove').forEach(function(a){
var raw=a.textContent.trim();
var key=groupKey(raw);
if(!keys.has(key)||!known.has(slug(raw)))return;
var row=a.closest('.applied__filter-item')||a.parentElement;
if(visited.has(key)){row.dataset.kdkMenChipHidden='1';return;}
visited.add(key);
row.removeAttribute('data-kdk-men-chip-hidden');
var pretty=labelFor(raw);
var textNode=Array.prototype.slice.call(a.childNodes).reverse().find(function(n){return n.nodeType===3&&n.textContent.trim();});
if(textNode)textNode.textContent=' '+pretty;
else{var word=a.querySelector('.kdk-men-chip-word');if(!word){word=document.createElement('span');word.className='kdk-men-chip-word';a.appendChild(word);}word.textContent=pretty;}
var kept=selected.filter(function(value){return groupKey(value)!==key;});
var next=new URL(window.location.href);
next.searchParams.delete(facetName);
if(kept.length)next.searchParams.set(facetName,kept.join(','));
next.searchParams.delete('page');
next.hash='CollectionProductsParent';
a.href=next.pathname+next.search+next.hash;
a.setAttribute('aria-label',pretty+' filtresini kaldır');
});
}

function preparePremiumCategories(form){
  if(form.dataset.kdkPremiumCategoryReady === '1')return;
  var fields=Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"][name="filter.p.t.category"]'));
  if(!fields.length)return;
  var details=fields[0].closest('.collection-filter-wrapper');
  if(!details)return;
  var native=details.querySelector('.collection-filter-item');
  if(!native)return;
  form.dataset.kdkPremiumCategoryReady='1';
  fields.forEach(function(field){field.removeAttribute('name');});
  var current=new URL(window.location.href);
  var active=current.searchParams.get('filter.p.t.category')||'';
  var hidden=document.createElement('input');
  hidden.type='hidden';hidden.name='filter.p.t.category';hidden.value=active;
  hidden.disabled=!active;hidden.dataset.kdkMenCategoryValue='1';
  form.appendChild(hidden);
  native.hidden=true;
  native.setAttribute('aria-hidden','true');
  var nav=document.createElement('nav');
  nav.className='kdk-men-premium-facets';
  nav.setAttribute('aria-label','Erkek ürün kategorilerini seç');
  var options=PREMIUM_MEN_CATEGORIES;
  var matched=false;
  options.forEach(function(item){
    var label=item[0],ids=item[1],group=item[2];
    if(group){
      var head=document.createElement('span');
      head.className='kdk-men-premium-facets__group';
      head.textContent=group;
      nav.appendChild(head);
    }
    var href=new URL(current.href);
    if(ids==='all')href.searchParams.delete('filter.p.t.category');
    else href.searchParams.set('filter.p.t.category',ids);
    href.searchParams.delete('page');
    href.hash='CollectionProductsParent';
    var anchor=document.createElement('a');
    anchor.className='kdk-men-premium-facets__link';
    anchor.href=href.pathname+href.search+href.hash;
    anchor.textContent=label;
    var selected=(ids==='all'&&active==='')||(ids===active);
    if(selected){anchor.classList.add('is-selected');anchor.setAttribute('aria-current','page');matched=true;}
    nav.appendChild(anchor);
  });
  if(active && !matched){
    var clear=new URL(current.href);
    clear.searchParams.delete('filter.p.t.category');
    clear.searchParams.delete('page');
    clear.hash='CollectionProductsParent';
    var reset=document.createElement('a');
    reset.className='kdk-men-premium-facets__reset';
    reset.textContent='Seçili kategoriyi kaldır ×';
    reset.href=clear.pathname+clear.search+clear.hash;
    nav.insertBefore(reset,nav.firstChild);
  }
  details.appendChild(nav);
}
var PREMIUM_MEN_CATEGORIES=[["Tüm Ürünler","all",""],["Üst Giyim","aa-1-13__aa-1-1-7__aa-1-1-2","GİYİM"],["Tişört","aa-1-13-8__aa-1-1-2-2",""],["Polo Yaka Tişört","aa-1-13-6",""],["Gömlek","aa-1-13-7",""],["Sweatshirt","aa-1-13-14__aa-1-1-7-4",""],["Kapüşonlu Sweatshirt","aa-1-13-13__aa-1-1-7-2",""],["Triko & Kazak","aa-1-13-12",""],["Dış Giyim","aa-1-10",""],["Mont & Ceket","aa-1-10-2",""],["Pantolon & Eşofman Altı","aa-1-12-11__aa-1-1-1-4__aa-1-1-1-6",""],["Şort","aa-1-1-1-3",""],["Sneaker","aa-8-8__aa-8-1","AYAKKABI"],["Bot","aa-8-3",""],["Günlük Ayakkabı","aa-8-9",""],["Terlik & Sandalet","aa-8-7__aa-8-6",""],["Omuz Çantası","aa-5-4-19","ÇANTA"],["Çapraz Çanta","aa-5-4-7",""],["Sırt Çantası","lb-1",""],["Bel Çantası","lb-7",""],["Cüzdan & Kartlık","aa-5-5-7","AKSESUAR"],["Kemer","aa-2-6",""],["Şapka & Bere","aa-2-17",""]];
function activate(){
if(!document.querySelector('[data-kdk-men]'))return;
document.body.classList.add('kdk-men-filter-refined');
var form=document.getElementById('FiltersForm');
if(!form)return;
if(form.dataset.kdkMenMergeReady==='1'){normalizeChips();return;}
var inputs=Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"][name="filter.p.product_type"]'));
if(!inputs.length){ensurePreview(form);return;}
form.dataset.kdkMenMergeReady='1';
var grouped=new Map();
inputs.forEach(function(input){
var li=input.closest('li');
if(!li)return;
var title=input.getAttribute('title')||(li.querySelector('label')||li).textContent.trim();
var key=groupKey(title);
if(!grouped.has(key))grouped.set(key,[]);
grouped.get(key).push({input:input,li:li,title:title,count:checkCount(li)});
});
var selectedGroups=[];
var lists=new Set();
grouped.forEach(function(items){
var first=items[0],li=first.li,label=li.querySelector('label[for]')||li.querySelector('.filter-hand-icon');
var isChecked=items.some(function(item){return item.input.checked;});
var available=items.some(function(item){return !item.input.disabled||item.input.checked;});
var count=items.reduce(function(sum,item){return sum+item.count;},0);
var display=labelFor(first.title);
if(label){label.textContent=display;label.title=display;}
first.input.title=display;
first.input.checked=isChecked;
first.input.disabled=!available;
li.classList.add('kdk-men-facet-row');
li.classList.toggle('is-selected',isChecked);
var countEl=li.querySelector('.count-numb');
if(countEl)countEl.textContent='('+count+')';
items.forEach(function(item,index){
item.input.removeAttribute('name');
item.input.dataset.kdkMenType='1';
if(index>0){
item.input.disabled=true;
item.li.dataset.kdkMenHide='1';
}
});
if(li.parentElement)lists.add(li.parentElement);
selectedGroups.push({input:first.input,items:items,li:li,display:display});
});
var hidden=document.createElement('input');
hidden.type='hidden';
hidden.name=facetName;
hidden.dataset.kdkMenCombined='1';
form.appendChild(hidden);
function sync(){
var values=[];
selectedGroups.forEach(function(group){
group.li.classList.toggle('is-selected',group.input.checked);
if(group.input.checked){
group.items.forEach(function(item){if(values.indexOf(item.input.value)===-1)values.push(item.input.value);});
}
});
hidden.disabled=values.length===0;
hidden.value=values.join(',');
}
form.addEventListener('click',function(e){
var input=e.target.closest&&e.target.closest('input[data-kdk-men-type]');
if(input&&input.disabled===false)sync();
},true);
form.addEventListener('change',sync,true);
sync();
ensurePreview(form);
var collator=new Intl.Collator('tr-TR',{sensitivity:'base'});
lists.forEach(function(list){
var rows=Array.prototype.slice.call(list.children);
rows.sort(function(a,b){
var ah=a.dataset.kdkMenHide==='1',bh=b.dataset.kdkMenHide==='1';
if(ah!==bh)return ah?1:-1;
var aa=(a.querySelector('label')||a).textContent.trim();
var bb=(b.querySelector('label')||b).textContent.trim();
return collator.compare(aa,bb);
});
rows.forEach(function(row){list.appendChild(row);});
});
normalizeChips();
}
var scheduled=false;
function schedule(){
if(scheduled)return;
scheduled=true;
Promise.resolve().then(function(){scheduled=false;activate();});
}
function start(){
activate();
var wrapper=document.querySelector('.collection-wrapper');
if(wrapper&&window.MutationObserver){
var observer=new MutationObserver(schedule);
observer.observe(wrapper,{childList:true,subtree:true});
}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',schedule);
window.addEventListener('popstate',schedule);
})();